import axios from "axios";
import { ReferenceTable } from "../../types/interfaces/admin/ReferenceResponse";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/reference-values/tables`;

export const getReferenceTableById = async (
  id: number,
): Promise<ReferenceTable> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const url = `${BASE_URL}/${id}`;

  const res = await axios.get(url, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};
